<table class="table table-hover table-striped">
  <thead>
  <tr>
    <th>{{ 'home.webcharges.overview.table.head.reference' | translate }}</th>
    <th>{{ 'home.webcharges.overview.table.head.cardNumber' | translate }}</th>
    <th>{{ 'home.webcharges.overview.table.head.paymentAmount' | translate }}</th>
    <th>{{ 'home.webcharges.overview.table.head.paymentProvider' | translate }}</th>
    <th>{{ 'home.webcharges.overview.table.head.status' | translate }}</th>
    <th>{{ 'home.webcharges.overview.table.head.created' | translate }}</th>
    <th>{{ 'home.webcharges.overview.table.head.updated' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngIf="webcharges.length > 0; else noEntries">
    <tr *ngFor="let w of webcharges" (click)="onOpenDetails(w.reference)">
      <td>{{ w.reference }}</td>
      <td>
        {{ w.cardNumber }}
      </td>
      <td>{{ w.payment ? (w.payment.amount/100 | currency:w.payment.currency) : '—' }}</td>
      <td>{{ w.payment ? ('shared.payment-provider.' + w.payment.paymentProvider | translate) : '—' }}</td>
      <td>{{ 'home.webcharges.overview.table.status.' + w.status | translate }}</td>
      <td>{{ w.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      <td>{{ w.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
    </tr>
  </ng-container>
  <ng-template #noEntries>
    <tr>
      <td colspan="7">
        {{ 'home.webcharges.overview.table.no-entries' | translate }}
      </td>
    </tr>
  </ng-template>
  </tbody>
</table>
